import React,{useEffect,useState} from 'react'
import RegisterHeader from '../../components/common/RegisterHeader'
import RegisterForm from '../../components/Auth/RegisterForm'
import { Link,useNavigate,useLocation } from 'react-router-dom'
import queryString from 'query-string'
import StudentImg from '../../assets/images/register-right.png'

const Register = () => {

    const navigate = useNavigate();
    const[utmParams,setUtmParams]=useState({})
    const location = useLocation();
    const qParams = queryString.parse(location.search);
    

    useEffect(() => {
        window.gtag("config", "UA-185641939-1", {
        page_title: location.pathname,
        page_path:location.pathname,
        })
      }, [location]);
      
        useEffect(() => {
          window.gtag("config", "GTM-WD9H59N", {
          page_title: location.pathname,
          page_path:location.pathname,
          })
      }, [location]);
      
    useEffect(() => {
        
        if(sessionStorage.getItem('token')){
            navigate('/student/dashboard');
        }
        
        if (qParams !== null) {
            const{channel_name,current_channel_name,source,lead_source,campaign_name,utm_adgroup,utm_campaign,utm_medium,utm_source,utm_term} =qParams
            let utmObj={
                channel_name:channel_name?channel_name:'',
                current_channel_name:current_channel_name?current_channel_name:'',
                source:source?source:'',
                lead_source:lead_source?lead_source:'',
                campaign_name:campaign_name?campaign_name:'',
                utm_adgroup:utm_adgroup?utm_adgroup:'',
                utm_campaign:utm_campaign?utm_campaign:'',
                utm_medium:utm_medium?utm_medium:'',
                utm_source:utm_source?utm_source:'',
                utm_term:utm_term?utm_term:'',
            }
            setUtmParams(utmObj)
        }
    },[])

    
  return (
    <>
    <RegisterHeader/>
    <div className="container mt-5">
        <div className="row gx-lg-4  login_register_form register_form_wrapper">
            <div className="col-md-12 col-lg-8">
                <div className="register_left login_left">
                    <div className="row">
                        <div className="col-lg-6">
                            <h2>Registration Form</h2>
                            <p>Already Have an account ? <Link to="/login" className="text-decoration-none text-primary fw-bold" title="Login Here">Please Login Here</Link></p>
                        </div>
                        <div className="col-lg-6 align-self-end">
                            <p className="fw-bold text-danger">* All Fields are mandatory </p>
                        </div>
                    </div>
                    <RegisterForm utmData={Object.keys(qParams).length> 0 ? utmParams:''}/>
                </div>
            </div>
       
            {/* Instructions */}
            <div className="col-md-4">
                <img src={StudentImg} className='img-fluid register_student_img d-none d-lg-block' alt="Register student" />
                {/* <div className="register_instructions ms-lg-3">
                    <h3>Instructions</h3>
                    <ul>
                        <li>An OTP (One Time Password) will be sent to your Registered  Mobile Number. Use that OTP to complete the Registration Process.</li>

                        <li>An Account Activation Link will be sent to your Registered Email-address along with Account Password.</li>
                        
                        <li>Click on that Activation Link to activate your Account.</li>
                        
                        <li>Use Your Registered Email-address and Account Password for login.</li>
                        
                        <li>After successfully logging in, you can fill/edit your Profile & Nomination details</li>
                        
                        <li>The last date for Registration & Nomination is 31st May 2023.</li>
                    </ul>
                </div> */}
            </div>
        </div>
    </div>
</>

  )
}

export default Register


